import {ICompanytemplate} from '../../../../taxpayer-management/taxpayers-setting/_models'

const shouldOpenStep4OptionalSection = (
  selectedTemplateId: number | undefined,
  templates: ICompanytemplate[],
  description: string,
  attachmentCount: number
) => {
  if (description.trim().length > 0 || attachmentCount > 0) return true
  if (!selectedTemplateId || selectedTemplateId <= 0 || templates.length === 0) return false

  const selectedTemplate = templates.find((template) => template.id === selectedTemplateId)
  return selectedTemplate ? selectedTemplate.isDefault !== true : true
}

export {shouldOpenStep4OptionalSection}
